import { useEffect, useRef, useState } from "react";
import { mediaUrl } from "../../lib/media";
import { BannerLink } from "./BannerLink";

/** Banner utama: gambar utuh (tanpa crop), tanpa teks/tombol di atasnya. */
export function HeroCarousel({ slides }) {
  const list = (slides || []).filter((s) => s?.gambar || s?.gambar_hp);
  const n = list.length;
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);
  const swipe = useRef({ x: 0, y: 0, moved: false });

  useEffect(() => {
    if (n <= 1 || paused) return;
    const t = setInterval(() => setI((p) => (p + 1) % n), 6000);
    return () => clearInterval(t);
  }, [n, paused]);

  if (!n) return null;
  const s = list[Math.min(i, n - 1)];

  const onTouchStart = (e) => {
    const t = e.touches[0];
    swipe.current = { x: t.clientX, y: t.clientY, moved: false };
  };
  const onTouchMove = (e) => {
    const t = e.touches[0];
    if (Math.abs(t.clientX - swipe.current.x) > 10 || Math.abs(t.clientY - swipe.current.y) > 10) {
      swipe.current.moved = true;
    }
  };
  const onTouchEnd = (e) => {
    const dx = (e.changedTouches?.[0]?.clientX ?? swipe.current.x) - swipe.current.x;
    if (Math.abs(dx) > 40 && n > 1) setI((p) => (dx < 0 ? (p + 1) % n : (p - 1 + n) % n));
  };
  const guardClick = (e) => { if (swipe.current.moved) e.preventDefault(); };

  const desktop = s.gambar || s.gambar_hp;
  const mobile = s.gambar_hp || s.gambar;
  const mini = s.gambar_mini || s.gambar_hp_mini || "";

  return (
    <section className="w-full" data-testid="hero-carousel">
      <div
        className="relative w-full overflow-hidden aspect-[2/1] md:aspect-[21/5]"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <BannerLink href={s.href} className="block absolute inset-0" tid={`hero-slide-${i}`} onClickCapture={guardClick}>
          <div className="absolute inset-0 bg-[#1D1D1F]" aria-hidden="true">
            {mini ? (
              <div className="absolute inset-0 bg-center bg-cover"
                   style={{ backgroundImage: `url(${mini})`, filter: "blur(14px)", transform: "scale(1.08)" }}
                   data-testid="hero-mini-blur" />
            ) : null}
          </div>
          <picture className="block w-full h-full">
            <source media="(max-width: 767px)" srcSet={mediaUrl(s.gambar_hp || s.gambar_960 || mobile)} />
            <img src={mediaUrl(desktop)} alt={s.alt || ""}
                 srcSet={s.gambar_960 ? `${mediaUrl(s.gambar_960)} 1470w, ${mediaUrl(desktop)} 2940w` : undefined}
                 sizes="100vw"
                 width="2940" height="700"
                 loading={i === 0 ? "eager" : "lazy"}
                 fetchPriority={i === 0 ? "high" : "auto"} decoding={i === 0 ? "sync" : "async"}
                 className="hero-img block w-full h-full object-cover object-center" />
          </picture>
        </BannerLink>
        {n > 1 && (
          <div className="absolute bottom-[14px] md:bottom-4 left-1/2 -translate-x-1/2 flex gap-2" data-testid="hero-dots">
            {list.map((_, idx) => (
              <button
                key={idx}
                aria-label={`Banner ${idx + 1}`}
                onClick={() => setI(idx)}
                className={`h-2 rounded-full transition-all ${idx === i ? "w-6 bg-[#FF6B1A]" : "w-2 bg-white/50"}`}
                data-testid={`hero-dot-${idx}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
